import React from "react";
import { QueryInterestProfile } from "types/gql-types";
type Interest = NonNullable<QueryInterestProfile["interest"]>;

const InterestAddress: React.FC<{interest: Interest, prefix: "mailing" | "residence"}> = ({ interest, prefix }) => {
  const address = interest[`${prefix}Address1` as "mailingAddress1" | "residenceAddress1"];
  const street = interest[`${prefix}SteNumber` as "mailingSteNumber" | "residenceSteNumber"];
  const city = interest[`${prefix}City` as "mailingCity" | "residenceCity"];
  const state = interest[`${prefix}State` as "mailingState" | "residenceState"];
  const zip = interest[`${prefix}Zip` as "mailingZip" | "residenceZip"];
  return (
    <address>
      {[address, street].filter(Boolean).join(", ")}
      {(address || street) && <br />}
      {[city, state].filter(Boolean).join(", ")} {zip}
    </address>
  );
};

export default InterestAddress;
